import { createSlice, current } from "@reduxjs/toolkit";

export interface IDashboardStateInterface {

}

const initialState: any = {
  isLoading: false,
  error: "",
  success: "",
  sketchColor: "rgba(150, 47, 123, 0.51)",
  oldsketchColor: "rgba(13, 13, 13, 1)",
  myProjectsBasedOnStatus: {},
  myCollaboratedProjectsBasedOnStatus: {},
  projectDetailsById: {},
  // isProjectDetailsFetched: false,
  artistDetailsBasedOnStatus: {},

  acceptedTermsData: [],

  isCollaboratorRemoved: false,
  isAppliedToProject: false,

  isInvitationTermsAccepted: false,
  appliedStatusOfProject: null,
  isCollaboratorRequestedAccepted: false,

  collaboratorRequirements: [],
  invitedArtistsForAProject: [],
  isInvitedArtistsFetched: false,
  isCollaboratorInvited: false,
  isInviteRejected: false,
  isExitedSuccefully: false,
  isNegotiatedSuccesfully: false,
  isProjectEnded: false,
  isProjectDeleted: false,
  projectMedias: [],

  projectContractData: {},

  isCollaboratorsFetched: false,
  collaboratorsByProjectId: {},

  isProjectTaskCreated: false,
  assignedUserOfTask: {},
  unAssignedUserOfTask: {},
  isAssignedUserRemoved: false,
  isTaskUpdated: false,
  isTaskDeleted: false,
  taskDetailsById: {},

  isPaginationLoading: false,
  // isRequestUpdated: false,

  endProjectDetails: {
    isProjectCompleted: 1,
    ratingsAndReviews: [

    ]
  },
  projectTasks: [],
  taskDetails: {
    taskTile: "",
    description: "",
    dueDate: null,
    collaborators: [],
  },
  isProjectDetailsFetchedById: false,
  projectOwnerTabValue: 0,
  projectListTabValues:0,
};

export const dashboardRedux: any = createSlice({
  name: 'dashboardRedux',
  initialState,
  reducers: {
    setDashboardState: (state: any, action: any) => {
      const newState = {
        ...state,
      }
      newState[action.payload.key] = action.payload.value
      return newState
    },

    getDashboardDataRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
      };
      return newState;
    },

    getDashboardDataSuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        dashboardData: action.payload.data,
        isLoading: false,
      };
      return newState;
    },

    getDashboardDataFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
      };
      return newState;
    },

    getAllMyProjectsBasedOnStatusRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
        isPaginationLoading: true,
      };
      return newState;
    },

    getAllMyProjectsBasedOnStatusSuccess: (state: any, action: any) => {
      const previousData = current(state?.myProjectsBasedOnStatus);

      const previousProjects = previousData?.responseData
        ? previousData?.responseData
        : [];

      let response = {
        ...action.payload.data
      }

      const formatedData = response?.currentPage === 1 ? [] : previousProjects;

      const newState = {
        ...state,
        myProjectsBasedOnStatus: {
          ...response,
          responseData: [...formatedData, ...response?.responseData],
        },
        isLoading: false,
        isPaginationLoading: false,
      };
      return newState;
    },

    getAllMyProjectsBasedOnStatusFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isPaginationLoading: false,
      };
      return newState;
    },

    getAllMyCollaboratedProjectsBasedOnStatusRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
        isPaginationLoading: true,
      };
      return newState;
    },

    getAllMyCollaboratedProjectsBasedOnStatusSuccess: (state: any, action: any) => {
      const previousData = current(state?.myCollaboratedProjectsBasedOnStatus);

      const previousProjects = previousData?.responseData
        ? previousData?.responseData
        : [];

      let response = {
        ...action.payload.data
      }

      const formatedData = response?.currentPage === 1 ? [] : previousProjects;

      const newState = {
        ...state,
        myCollaboratedProjectsBasedOnStatus: {
          ...response,
          responseData: [...formatedData, ...response?.responseData],
        },
        isLoading: false,
        isPaginationLoading: false,
      };
      return newState;
    },

    getAllMyCollaboratedProjectsBasedOnStatusFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isPaginationLoading: false,
      };
      return newState;
    },

    // fetch project details by id
    getProjectDetailsByIdRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
        isProjectDetailsFetchedById: false,
      };
      return newState;
    },

    getProjectDetailsByIdSuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        projectDetailsById: action.payload.data,
        isLoading: false,
        isProjectDetailsFetchedById: true,
      };
      return newState;
    },

    getProjectDetailsByIdFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isProjectDetailsFetchedById: false,
      };
      return newState;
    },

    // Apply to project
    applyProjectRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
      };
      return newState;
    },

    applyProjectSuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isAppliedToProject: true,
      };
      return newState;
    },

    applyProjectFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isAppliedToProject: false
      };
      return newState;
    },


    // Accept invitation
    acceptInvitationRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
      };
      return newState;
    },

    acceptInvitationSuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        // isInvitationAccepted: true,
        appliedStatusOfProject: action.payload.data
      };
      return newState;
    },

    acceptInvitationFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isInvitationAccepted: false
      };
      return newState;
    },


    // fetch all artists details of a project based on invite status
    getAllArtistsOfProjectByInviteStatusRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
        isPaginationLoading: true,
      };
      return newState;
    },

    getAllArtistsOfProjectByInviteStatusSuccess: (state: any, action: any) => {

      if (Array.isArray(action?.payload?.data?.responseData)) {
        const previousData = current(state?.artistDetailsBasedOnStatus);

        const previousArtists = previousData?.responseData
          ? previousData?.responseData
          : [];

        let response = {
          ...action.payload.data
        }

        const formatedData = response?.currentPage === 1 ? [] : previousArtists;

        const newState = {
          ...state,
          artistDetailsBasedOnStatus: {
            ...response,
            responseData: [...formatedData, ...response?.responseData],
          },
          isLoading: false,
          isPaginationLoading: false,
        };
        return newState;
      } else {
        const previousData = current(state?.artistDetailsBasedOnStatus);
        const previousArtists = previousData?.responseData?.otherCollaborators
          ? previousData?.responseData?.otherCollaborators
          : [];

        let response = {
          ...action.payload.data
        }

        const formatedData = response?.currentPage === 1 ? [] : previousArtists;

        const newState = {
          ...state,
          artistDetailsBasedOnStatus: {
            ...response,
            responseData: {
              ...response?.responseData,
              otherCollaborators: [...formatedData, ...response?.responseData?.otherCollaborators],
              selfDetails: response?.currentPage === 1 ? response?.responseData?.selfDetails : previousData?.responseData?.selfDetails,
              projectOwnerDetails: response?.currentPage === 1 ? response?.responseData?.projectOwnerDetails : previousData?.responseData?.projectOwnerDetails
            }
          },
          isLoading: false,
          isPaginationLoading: false,
        };
        return newState;
      }
    },

    getAllArtistsOfProjectByInviteStatusFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isPaginationLoading: false,
      };
      return newState;
    },

    removeCollaboratorByIdRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
      };
      return newState;
    },

    removeCollaboratorByIdSuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        isCollaboratorRemoved: true,
        isLoading: false,
      };
      return newState;
    },

    removeCollaboratorByIdFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isCollaboratorRemoved: false,
      };
      return newState;
    },

    getCollaboratorNegotiationDetailsRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
      };
      return newState;
    },

    getCollaboratorNegotiationDetailsSuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        acceptedTermsData: action.payload.data
      };
      return newState;
    },

    getCollaboratorNegotiationDetailsFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
      };
      return newState;
    },

    acceptOrDeclineCollaborationRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
      };
      return newState;
    },

    acceptOrDeclineCollaborationSuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isCollaboratorRequestedAccepted: true
      };
      return newState;
    },

    acceptOrDeclineCollaborationFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
      };
      return newState;
    },

    // collaborator can reject the invitaion from project owner
    rejectProjectInviteRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
      };
      return newState;
    },

    rejectProjectInviteSuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isInviteRejected: true
      };
      return newState;
    },

    rejectProjectInviteFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
      };
      return newState;
    },

    inviteCollaboratorRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
      };
      return newState;
    },

    inviteCollaboratorSuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isCollaboratorInvited: true
      };
      return newState;
    },

    inviteCollaboratorFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
      };
      return newState;
    },

    getAllInvitedCollaboratorsRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
      };
      return newState;
    },

    getAllInvitedCollaboratorsSuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isInvitedArtistsFetched: true,
        invitedArtistsForAProject: action.payload.data
      };
      return newState;
    },

    getAllInvitedCollaboratorsFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
      };
      return newState;
    },


    exitProjectRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
      };
      return newState;
    },

    exitProjectSuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isExitedSuccefully: true,
      };
      return newState;
    },

    exitProjectFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
      };
      return newState;
    },


    reNegotiationRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
      };
      return newState;
    },

    reNegotiationSuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isNegotiatedSuccesfully: true,
      };
      return newState;
    },

    reNegotiationFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isNegotiatedSuccesfully: false,
      };
      return newState;
    },

    //end project
    endProjectRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
      };
      return newState;
    },

    endProjectSuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isProjectEnded: true,
      };
      return newState;
    },

    endProjectFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isNegotiatedSuccesfully: false,
      };
      return newState;
    },

    //rate all project members 
    rateProjectRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
      };
      return newState;
    },

    rateProjectSuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
      };
      return newState;
    },

    rateProjectFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
      };
      return newState;
    },

    // project contract api
    getProjectContractRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
      };
      return newState;
    },

    getProjectContractSuccess: (state: any, action: any) => {
      const response = action.payload.data;
      const newState = {
        ...state,
        isLoading: false,
        projectContractData: response,
      };
      return newState;
    },

    getProjectContractFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
      };
      return newState;
    },


    getAllCollaboratorsRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
      };
      return newState;
    },

    getAllCollaboratorsSuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        collaboratorsByProjectId: action.payload.data,
        isCollaboratorsFetched: true
      };
      return newState;
    },

    getAllCollaboratorsFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isCollaboratorsFetched: false
      };
      return newState;
    },

    // get all project members
    getAllProjectMembersRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
      };
      return newState;
    },

    getAllProjectMembersSuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        collaboratorsByProjectId: action.payload.data,
        isCollaboratorsFetched: true
      };
      return newState;
    },

    getAllProjectMembersFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isCollaboratorsFetched: false
      };
      return newState;
    },

    deleteProjectRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
      };
      return newState;
    },

    deleteProjectSuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isProjectDeleted: true
      };
      return newState;
    },

    deleteProjectFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isProjectDeleted: false
      };
      return newState;
    },

    getProjectMediasRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
      };
      return newState;
    },

    getProjectMediasSuccess: (state: any, action: any) => {

      const data = action?.payload?.data?.responseData?.map((item: any) => ({
        ...item,
        isPlaying: false,
        isMute: false,
      }));
      const newState = {
        ...state,
        isLoading: false,
        projectMedias: {
          ...action?.payload?.data,
          responseData: data
        }
        // isProjectDeleted: true
      };
      return newState;
    },

    getProjectMediasFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isProjectDeleted: false
      };
      return newState;
    },

    // Project tasks apis
    // Read (fetch) all project tasks by project id
    getProjectTasksRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
        isPaginationLoading: true,
      };
      return newState;
    },

    getProjectTasksSuccess: (state: any, action: any) => {
      // const newState = {
      //   ...state,
      //   isLoading: false,
      //   projectTasks: action.payload.data,

      // };
      // return newState;
      const previousData = current(state?.projectTasks);

      const previousProjects = previousData?.responseData
        ? previousData?.responseData
        : [];

      let response = action.payload.data;
      console.log(response, "line responseee")
      const formatedData = response?.currentPage === 1 ? [] : previousProjects;

      const newState = {
        ...state,
        projectTasks: {
          ...response,
          responseData: [...response],
        },
        isLoading: false,
        isPaginationLoading: false,
      };
      return newState;

    },

    getProjectTasksFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isCollaboratorsFetched: false,
        isPaginationLoading: false,
      };
      return newState;
    },

    // Read (fetch) all project tasks
    getAllProjectTasksRequest: (state) => {
      state.isLoading = true;
    },
    getAllProjectTasksSuccess: (state, action) => {
      let response = action.payload.data;
      const newState = {
        ...state,
        projectTasks: {
          ...response,
          responseData: [...response],
        },
        isLoading: false,
        isPaginationLoading: false,
      };
      return newState;

    },
    getAllProjectTasksFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },

    //create project tasks apis
    createProjectTaskRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
        isProjectTaskCreated: false
      };
      return newState;
    },

    createProjectTaskSuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isProjectTaskCreated: true
      };
      return newState;
    },

    createProjectTaskFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isProjectTaskCreated: false
      };
      return newState;
    },

    getAllAssigneesByTaskIdRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
        isPaginationLoading: true,
      };
      return newState;
    },

    getAllAssigneesByTaskIdSuccess: (state: any, action: any) => {
      const previousData = current(state?.assignedUserOfTask);

      const previousProjects = previousData?.responseData
        ? previousData?.responseData
        : [];

      let response = {
        ...action.payload.data
      }

      const formatedData = response?.currentPage === 1 ? [] : previousProjects;

      const newState = {
        ...state,
        assignedUserOfTask: {
          ...response,
          responseData: [...formatedData, ...response?.responseData],
        },
        isLoading: false,
        isPaginationLoading: false,
      };
      return newState;
    },

    getAllAssigneesByTaskIdFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isPaginationLoading: false,
      };
      return newState;
    },

    getAllUnassignedArtistsByTaskIdRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
      };
      return newState;
    },

    getAllUnassignedArtistsByTaskIdSuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        unAssignedUserOfTask: action?.payload?.data
        // isProjectTaskCreated: true
      };
      return newState;
    },

    getAllUnassignedArtistsByTaskIdFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        // isProjectTaskCreated: false
      };
      return newState;
    },

    removeAssignedArtistsRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
      };
      return newState;
    },

    removeAssignedArtistsSuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isAssignedUserRemoved: true
      };
      return newState;
    },

    removeAssignedArtistsFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isAssignedUserRemoved: false
      };
      return newState;
    },

    updateTaskByIdRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
        isTaskUpdated: false
      };
      return newState;
    },

    updateTaskByIdSuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isTaskUpdated: true
      };
      return newState;
    },

    updateTaskByIdFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isTaskUpdated: false
      };
      return newState;
    },

    //delete task
    deleteTaskRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
        isTaskDeleted: false
      };
      return newState;
    },

    deleteTaskSuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isTaskDeleted: true
      };
      return newState;
    },

    deleteTaskFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isTaskDeleted: false
      };
      return newState;
    },


    getTaskDetailsByIdRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
      };
      return newState;
    },

    getTaskDetailsByIdSuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        taskDetailsById: action?.payload?.data
      };
      return newState;
    },

    getTaskDetailsByIdFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        // isProjectTaskCreated: false
      };
      return newState;
    },

    selfTaskAssignmentRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
      };
      return newState;
    },

    selfTaskAssignmentSuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isProjectTaskCreated: true
      };
      return newState;
    },

    selfTaskAssignmentFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isProjectTaskCreated: false
      };
      return newState;
    },

    //project - view - count
    projectViewCountRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
      };
      return newState;
    },

    projectViewCountSuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isProjectTaskCreated: true
      };
      return newState;
    },

    projectViewCountFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isProjectTaskCreated: false
      };
      return newState;
    },

  },

})

export const {
  setDashboardState,

  getDashboardDataRequest,
  getDashboardDataSuccess,
  getDashboardDataFailure,

  getAllMyProjectsBasedOnStatusRequest,
  getAllMyProjectsBasedOnStatusSuccess,
  getAllMyProjectsBasedOnStatusFailure,

  getAllMyCollaboratedProjectsBasedOnStatusRequest,
  getAllMyCollaboratedProjectsBasedOnStatusSuccess,
  getAllMyCollaboratedProjectsBasedOnStatusFailure,

  getProjectDetailsByIdRequest,
  getProjectDetailsByIdSuccess,
  getProjectDetailsByIdFailure,

  applyProjectRequest,
  applyProjectSuccess,
  applyProjectFailure,

  acceptInvitationRequest,
  acceptInvitationSuccess,
  acceptInvitationFailure,

  getAllArtistsOfProjectByInviteStatusRequest,
  getAllArtistsOfProjectByInviteStatusSuccess,
  getAllArtistsOfProjectByInviteStatusFailure,

  removeCollaboratorByIdRequest,
  removeCollaboratorByIdSuccess,
  removeCollaboratorByIdFailure,

  getCollaboratorNegotiationDetailsRequest,
  getCollaboratorNegotiationDetailsSuccess,
  getCollaboratorNegotiationDetailsFailure,

  acceptOrDeclineCollaborationRequest,
  acceptOrDeclineCollaborationSuccess,
  acceptOrDeclineCollaborationFailure,

  rejectProjectInviteRequest,
  rejectProjectInviteSuccess,
  rejectProjectInviteFailure,

  inviteCollaboratorRequest,
  inviteCollaboratorSuccess,
  inviteCollaboratorFailure,

  getAllInvitedCollaboratorsRequest,
  getAllInvitedCollaboratorsSuccess,
  getAllInvitedCollaboratorsFailure,

  exitProjectRequest,
  exitProjectSuccess,
  exitProjectFailure,

  reNegotiationRequest,
  reNegotiationSuccess,
  reNegotiationFailure,

  endProjectRequest,
  endProjectSuccess,
  endProjectFailure,

  rateProjectRequest,
  rateProjectSuccess,
  rateProjectFailure,

  getProjectContractRequest,
  getProjectContractSuccess,
  getProjectContractFailure,

  getAllCollaboratorsRequest,
  getAllCollaboratorsSuccess,
  getAllCollaboratorsFailure,

  getAllProjectMembersRequest,
  getAllProjectMembersSuccess,
  getAllProjectMembersFailure,

  deleteProjectRequest,
  deleteProjectSuccess,
  deleteProjectFailure,

  getProjectMediasRequest,
  getProjectMediasSuccess,
  getProjectMediasFailure,

  getProjectTasksRequest,
  getProjectTasksSuccess,
  getProjectTasksFailure,

  getAllProjectTasksRequest,
  getAllProjectTasksSuccess,
  getAllProjectTasksFailure,

  createProjectTaskRequest,
  createProjectTaskSuccess,
  createProjectTaskFailure,

  getAllAssigneesByTaskIdRequest,
  getAllAssigneesByTaskIdSuccess,
  getAllAssigneesByTaskIdFailure,

  getAllUnassignedArtistsByTaskIdRequest,
  getAllUnassignedArtistsByTaskIdSuccess,
  getAllUnassignedArtistsByTaskIdFailure,

  removeAssignedArtistsRequest,
  removeAssignedArtistsSuccess,
  removeAssignedArtistsFailure,

  updateTaskByIdRequest,
  updateTaskByIdSuccess,
  updateTaskByIdFailure,

  deleteTaskRequest,
  deleteTaskSuccess,
  deleteTaskFailure,

  getTaskDetailsByIdRequest,
  getTaskDetailsByIdSuccess,
  getTaskDetailsByIdFailure,

  selfTaskAssignmentRequest,
  selfTaskAssignmentSuccess,
  selfTaskAssignmentFailure,

  projectViewCountRequest,
  projectViewCountSuccess,
  projectViewCountFailure

} = dashboardRedux.actions

export default dashboardRedux.reducer

